export function orderedWorkflowVersions(workflow) {
  const defaultId =
    workflow?.defaultVersion?.id || workflow?.currentPublishedVersion?.id;
  return [...(workflow?.versions || [])].sort(
    (left, right) =>
      Number(right.id === defaultId) - Number(left.id === defaultId) ||
      Number(right.versionNumber) - Number(left.versionNumber),
  );
}
